<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :selectedIndex="selectedIndex"
    :baseView="baseView"
    :formsConfig="formsConfig"
    :key="baseView.mode"
    :hot-key-create-path="`/customer-type/create`"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
  >
    <template #headerContent>
      <GcHeaderContentStatic title="Customer Type" />
    </template>
    <div class="customer-type split-view-template css-v2 split-view">
      <gc-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
      >
        <template #leftContent>
          <div>
            <gc-filter-split-view
              :showLeftContainer="showFilterLeftContainer"
              :showRightContainer="showFilterRightContainer"
            >
              <template #leftContent>
                <div class="css-v2 split-view-list">
                  <dx-data-grid
                    :data-source="dataSourceConfig"
                    :columns="columns"
                    :height="gridHeight - 24"
                    @cell-click="onRowClicked($event, rowSelect)"
                    @toolbar-preparing="onToolbarPreparing($event)"
                    @context-menu-preparing="
                      onContextMenuPreparing($event, rowSelect)
                    "
                    @content-ready="addGridNoResults($event)"
                    :selection="{ mode: 'single' }"
                    @exporting="
                      onGridToExcelExporting($event, `Customer Type`, columns)
                    "
                    :ref="'customer-type'"
                  >
                    <DxExport :enabled="true" />
                    <template #active-cell-template="{ data }">
                      <GcInactive :inactive="data.data.Inactive" />
                    </template>

                    <template #customer-type-cell-template="{ data }">
                      <GcDescriptionCodeCellTemplate
                        :description="data.data.Description"
                        :code="data.data.Code"
                      />
                    </template>

                    <template #RadioTemplate="{ data }">
                      <GcFieldRadio
                        :value="data.data.IsDefault"
                        :data="data"
                        :valueChangeCallBack="radioValueChange"
                        :disabled="data.data.Inactive == 'Y'"
                      />
                    </template>
                    <template #Decimal="{ data }">
                      <GcDecimal
                        :dataValue="data"
                        :format="data.column.format"
                      />
                    </template>
                  </dx-data-grid>
                </div>
              </template>
              <template #rightContent>
                <gc-advance-filter-panel
                  :toolbar="filterToolbar"
                  :setFilterFormHeight="filterFormHeight"
                  :sideBarTabs="sideBarTabs"
                  :filterFormItems="filterFormItems"
                  :filterModel="getAdvanceFilterModel"
                  :isJson="false"
                  :screenType="'supplier-contact-list'"
                  :data-source-config="dataSourceConfig"
                >
                </gc-advance-filter-panel>
              </template>
            </gc-filter-split-view>
          </div>
        </template>

        <template #rightContent>
          <DxToolbar class="split-view-toolbar">
            <DxItem #default location="before" locate-in-menu="never">
              <div class="toolbar-label">
                <span class="text-primary">{{ model.Code }}</span>
              </div>
            </DxItem>
            <DxItem
              widget="dxForm"
              location="after"
              :options="{
                formData: model,
                items: toolbarActiveItems,
                validationGroup: formsConfig.validationGroup,
                labelLocation: 'left',
              }"
              locate-in-menu="after"
              :disabled="baseView.mode == 'review' ? true : false"
            ></DxItem>
            <DxItem
              :options="toolbar.audit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode == 'review'"
            />
            <DxItem
              :options="toolbar.edit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode == 'review'"
              :visible="formsConfig.editableOption"
            />
            <DxItem
              :options="toolbar.save"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode != 'review'"
            />
            <DxItem
              :options="toolbar.close"
              location="after"
              widget="dxButton"
            />
          </DxToolbar>
          <div class="view-card responsive-paddings split-view-form">
            <form>
              <DxForm
                :form-data.sync="model"
                :read-only="false"
                :show-colon-after-label="false"
                :show-required-mark="false"
                :show-validation-summary="false"
                :validation-group="formsConfig.validationGroup"
                :col-count-by-screen="formsConfig.splitViewColCountByScreen"
                label-location="left"
                :customizeItem="customizeItem"
                :items="items"
              ></DxForm>
            </form>
          </div>
        </template>
      </gc-split-view>
    </div>
  </gc-main-layout>
</template>

<script>
import { CustomerTypeService } from "../../../_services/api/settings/customers/customer-type.service";

import BaseViewMixin from "../../../v1/_mixins/base.view";
import validationEngine from "devextreme/ui/validation_engine";

export default {
  components: {},
  mixins: [BaseViewMixin],
  created() {
    this.selectedIndex = 0;
  },
  mounted() {
    validationEngine.validateGroup(this.formsConfig.validationGroup);
  },
  updated() {
    validationEngine.validateGroup(this.formsConfig.validationGroup);
  },
  data() {
    return {
      toolbar: {
        close: {
          icon: "close",

          onClick: () => {
            this.$router
              .push({
                path: "/customer-type",
              })
              .then((res) => {
                if (res)
                  setTimeout(() => {
                    this.reSizeGrid();
                  }, 50);
              });
          },
        },
        edit: {
          icon: "edit",

          onClick: () => {
            this.$router.push({
              path: `/customer-type/edit/${this.baseView.id}`,
            });
          },
        },
        save: {
          icon: "floppy",
          validationGroup: "formsData",
          onClick: (e) => {
            this.$logger.trackEventButtonClickSave();
            this.saveCustomerType(e);
          },
        },
        audit: {
          icon: "clock",

          onClick: () => {
            this.displayAuditPopup(
              this.model.CreatedBy,
              this.model.DateCreated,
              this.model.ChangedBy,
              this.model.DateChanged
            );
          },
        },
      },
      advanceFilterModel: {
        Inactive: "",
      },
      model: {
        Code: "",
        Discount: 0.0,
        Description: "",
        Active: true,
        DateChanged: "",
        DateCreated: "",
        ChangedBy: "",
        CreatedBy: "",
        IsDefault: true,
        IsDefaultData: false,
      },
      rowSelect: {
        view: this,
        page: "customer-type",
        mode: "review",
        idProperty: "Code",
      },
    };
  },
  computed: {
    getAdvanceFilterModel() {
      return this.advanceFilterModel;
    },
    filterFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: this.parseFormColumns([
            {
              dataField: "Inactive",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Status",
              editorOptions: {
                items: [
                  {
                    text: "Active",
                    value: "N",
                  },
                  {
                    text: "Inactive",
                    value: "Y",
                  },
                ],
                valueExpr: "value",
                displayExpr: "text",
              },
            },
          ]),
        },
      ];
    },
    items() {
      let formFields = [
        {
          itemType: "group",
          caption: "",
          items: this.parseFormColumns([
            {
              dataField: "Code",
              visible: this.baseView.mode == "create",
              gcLabel: "Type",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 2,
              },
              required: true,
            },
            {
              dataField: "Description",
              gcLabel: "Description",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 15,
              },
              required: true,
            },
            {
              dataField: "Discount",
              gcLabel: "Discount %",
              gcType: "String",
              editorType: "dxNumberBox",
              editorOptions: {
                min: 0.0,
                max: 99.99,
              },
              required: true,
            },
            {
              dataField: "IsDefault",
              gcLabel: "Default",
              gcType: "String",
              editorType: "dxSwitch",
              editorOptions: {
                readOnly:
                  this.model["IsDefaultData"] || !this.model["Active"]
                    ? true
                    : false,
              },
            },
          ]),
        },
      ];

      return formFields;
    },
    columns() {
      return this.parseGridColumns("master", [
        {
          gcLabel: "Type",
          dataField: "Description",
          cellTemplate: "customer-type-cell-template",
          gcType: "String",
          gcSubType: "PrimaryRecord",
          gcExport: ["Code", "Description"],
        },
        {
          gcLabel: "Discount %",
          dataField: "Discount",
          gcType: "Decimal-6-2",
          cellTemplate: "Decimal",
          // width: 120,
        },
        {
          gcLabel: "Changed By",
          dataField: "ChangedBy",
          gcType: "String",
          width: 120,
        },
        {
          gcType: "String",
          gcSubType: "Chip",
          dataField: "Inactive",
          cellTemplate: "active-cell-template",
        },
        {
          gcLabel: "Code",
          dataField: "Code",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
        },
        {
          gcLabel: "Description",
          dataField: "Description",
          minWidth: this.gridColumnMinWidth(220),
          gcType: "String",
          gcSubType: "HiddenDescription",
        },
        {
          gcType: "String",
          gcLabel: "Default",
          gcSubType: "IsDefault",
          dataField: "IsDefault",
          width: 75,
          cellTemplate: "RadioTemplate",
        },
      ]);
    },
    toolbarActiveItems() {
      return this.parseFormColumns([
        {
          dataField: "Active",
          gcType: "Boolean",
          gcLabel: "Active",
          editorOptions: {
            readOnly: this.model["IsDefault"] ? true : false,
          },
        },
      ]);
    },
    dataSourceConfig() {
      return CustomerTypeService.dataSourceConfig("api/CustomerType", {
        // select: ["Code", "Description", "Inactive", "ChangedBy"],
        // sort: [{ selector: "Code", desc: false }],
        postProcess: (data) => {
          data.forEach((element) => {
            if (element.IsDefault == "Y" && this.baseView.id != element.Code)
              this.markDefault(false);
          });

          return data;
        },
      });
    },
    // tabs() {
    //   return [
    //     {
    //       text: "Customer Type",
    //       path: `/customer-type`,
    //       applicationFeatureCode: "CustomerType",
    //     },
    //     {
    //       text: "Customer Group",
    //       path: `/customer-group`,
    //       applicationFeatureCode: "CustomerGroup",
    //     },
    //   ];
    // },
    showLeftContainer() {
      return !(this.isXSmall && this.baseView.mode !== "");
    },
    showRightContainer() {
      return !(this.baseView.mode == "review" && this.baseView.id == "");
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler: "handleLocalRouteChange",
    },
  },
  methods: {
    markDefault(value) {
      this.model.IsDefault = value;
    },
    async radioValueChange(cellInfo, event) {
      if (event.value) {
        let grid = this.$refs["customer-type"].instance;
        var items = grid.getDataSource().items();
        var getDefault,
          clickedDefault = undefined;
        if (items)
          items.forEach((element) => {
            if (element.Code == cellInfo.data.Code)
              clickedDefault = element.Description;
            if (element.IsDefault == "Y") getDefault = element.Description;
          });
        let confirmDefault = await this.$confirm(
          `Do you want to change the default setting from ${getDefault} to ${clickedDefault} ?`,
          "Default Setting Change"
        );
        if (!confirmDefault) {
          event.component.beginUpdate();
          event.component.option("value", false);
          event.component.endUpdate();
          return;
        }
        this.showLoading(true);
        await CustomerTypeService.markAsDefault({
          Code: cellInfo.data.Code,
        })
          .then((res) => {
            if (!res) this.showLoading(false);
            let grid = this.$refs["customer-type"].instance;
            var items = grid.getDataSource().items();
            if (items)
              items.forEach((element) => {
                if (element.Code == cellInfo.data.Code) element.IsDefault = "Y";
                else element.IsDefault = "N";
              });

            if (
              (this.model.IsDefault && cellInfo.data.Code != this.model.Code) ||
              (!this.model.IsDefault && cellInfo.data.Code == this.model.Code)
            )
              this.getFormData();
            else this.showLoading(false);
          })
          .catch((err) => {
            if (err) {
              event.component.beginUpdate();
              event.component.option("value", false);
              event.component.endUpdate();
              this.showLoading(false);
            }
          });
      }
    },
    getFormData() {
      let that = this;
      this.getRecord()
        .then((response) => {
          if (response.data.value.length > 0) {
            this.model.Code = response.data.value[0].Code;
            this.model.Description = response.data.value[0].Description;
            this.model.Active = response.data.value[0].Inactive == "N";
            this.model.DateChanged = response.data.value[0].DateChanged;
            this.model.DateCreated = response.data.value[0].DateCreated;
            this.model.ChangedBy = response.data.value[0].ChangedBy;
            this.model.CreatedBy = response.data.value[0].CreatedBy;
            this.model.Discount = response.data.value[0].Discount;
            this.model.IsDefault =
              response.data.value[0].IsDefault == "Y" ? true : false;
            this.model.IsDefaultData =
              response.data.value[0].IsDefault == "Y" ? true : false;
            that.refreshView();
            this.showLoading(false);
          }
        })
        .catch((err) => {
          if (err) this.showLoading(false);
        });
    },
    backButtonFunction() {
      this.$router.push({
        path: "/settings/customers",
      });
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });
      var exportButton = toolbarItems.find((item) => {
        return item.name === "exportButton";
      });
      var columnChooserButton = toolbarItems.find((item) => {
        return item.name === "columnChooserButton";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return (
          item.name !== "exportButton" &&
          item.name !== "searchPanel" &&
          item.name !== "columnChooserButton"
        );
      });

      searchPanel.location = "after";
      exportButton.location = "after";

      e.toolbarOptions.items.unshift(
        {
          location: "before",
          widget: "dxButton",
          options: {
            icon: "plus",
            text: "Add New",
            onClick: async () => {
              await CustomerTypeService.getItems({
                url: "api/CustomerType",
                select: "Code,IsDefault",
                filter: "IsDefault eq 'Y'",
                count: true,
              })
                .then((res) => {
                  if (res.data.value.length > 0) this.model.IsDefault = false;
                  else this.model.IsDefault = true;
                })
                .catch((err) => {
                  if (err) this.model.IsDefault = true;
                });
              this.$logger.trackEventButtonClickAddNew();
              this.model.Discount = 0;
              this.model.Code = "";
              this.model.Description = "";
              this.model.Active = true;
              this.model.IsDefaultData = false;
              this.$router.push({
                path: "/customer-type/create",
              });
            },
          },
        },
        searchPanel,
        exportButton,
        columnChooserButton,
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            icon: "filter",
            elementAttr: { id: "filter-btn" },
            onClick: () => {
              this.showFilterRightContainer = !this.showFilterRightContainer;
              var item = document.getElementById("filter-btn");
              this.$logger.debug("item ", item);
              item.classList.add("dx-state-invisible");
            },
          },
        }
      );
    },
    handleLocalRouteChange() {
      if (
        (this.baseView.mode === "review" || this.baseView.mode === "edit") &&
        this.baseView.id
      ) {
        this.model.Code = this.baseView.id;
        this.getFormData();
      }
    },
    async getRecord() {
      return CustomerTypeService.getByCode(this.baseView.id);
    },
    async saveCustomerType(e) {
      const result = await e.validationGroup.validate();
      if (!result.isValid) {
        this.displayValidationSummary();
        return;
      }

      this.showLoading(true);

      await CustomerTypeService.save(this.baseView.mode, {
        Code: this.model.Code,
        Description: this.model.Description,
        Inactive: this.model.Active ? "N" : "Y",
        IsDefault: this.model.IsDefault ? "Y" : "N",
        Discount: this.model.Discount,
      })
        // eslint-disable-next-line no-unused-vars
        .then((res) => {
          this.showLoading(false);
          // eslint-disable-next-line no-console
          // this.$logger.debug("saveCustomerType", res);
          this.$notify(
            `Customer Type ${this.model.Code} saved successfully`,
            "success"
          );
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/customer-type/review/${this.model.Code}`,
          });
        })
        .catch((error) => {
          this.displayServerError(error, "Customer Type save failed");
        });
    },
  },
};
</script>

<style lang="scss">
.customer-type {
  .split-view-toolbar {
    margin: unset !important;
  }

  .dx-button.dx-button-has-icon.dx-button-has-text[aria-label="Add New"] {
    height: 25px;
    .dx-button-content {
      padding: 3px;
    }
    .dx-icon {
      font-size: 12px;
      margin-right: 0px;
      padding: 0px;
      // margin-top: 2px;
    }
    .dx-button-text {
      font-size: 10px;
    }
  }
}
</style>
